import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
} from "@mui/material";

export const CreateZoneDialog = ({
  open,
  onClose,
  saving,
  onSave,
  errors = {},
}) => {
  const [zone, setZone] = useState({ name: "", code: "" });

  const handleChange = (e) => {
    setZone({ ...zone, [e.target.name]: e.target.value });
  };

  const submit = () => {
    onSave(zone);
    setZone({ name: "", code: "" }); // Reset after save
  };

  return (
    <Dialog
      open={open}
      onClose={!saving ? onClose : undefined}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Create New Zone</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Zone Name"
              name="name"
              value={zone.name}
              onChange={handleChange}
              disabled={saving}
              error={!!errors.name}
              helperText={errors.name?.[0]}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Zone Code (Unique)"
              name="code"
              value={zone.code}
              onChange={handleChange}
              disabled={saving}
              error={!!errors.code}
              helperText={errors.code?.[0]}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          Cancel
        </Button>
        <Button onClick={submit} variant="contained" disabled={saving}>
          {saving ? "Creating..." : "Create"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
